<template>
  <aside class="sidebar_right">
    <dd-register-modal
      ref="RegisterModalRef"
      :isOpen="isOpen"
      :fileData="detailData"
      @showDetail="showDetail"
    />
    <div class="container" id="info_head">
      <h2>詳細情報</h2>
      <ul>
        <li class="main_btn" v-on:mouseover="isOnSheet(true)" v-on:mouseleave="isOnSheet(false)">
          <img :src="imgSheet" alt="new" width="28px" height="auto" >図面/製造指示書プレビュー
        </li>
        <li class="main_btn" @click="onRegister" v-on:mouseover="isOnSave(true)" v-on:mouseleave="isOnSave(false)">
          <img :src="imgSave" alt="new" width="28px" height="auto" >ユニット{{ isOpen ? '登録' : '公開'}}
        </li>
        <li class="main_btn" @click="onDelete" v-if="!isOpen">削除</li>
      </ul>
    </div>
    <div class="container" id="info_content">
      <img :src="fileImg" alt="file_img" width="240px" height="240px" />
      <div class="unit_info">
        <h3 v-if="isOpen">{{ detailData.openFdName === null ? '公開ファイル名' : detailData.openFdName}}</h3>
        <h3 v-else>{{ detailData.fileName }}</h3>
        <span class="type_number " id="corp_name">{{ detailData.corpName }}</span><br>
        <span class="type_number">製品品番：{{ detailData.fileCode === null ? 'なし' : detailData.fileCode }}</span>
        <div class="container">
          <span class="category">
            <p>{{ grpName }}</p>
          </span>
        </div>
      </div>
    </div>
    <div id="tabs">
      <input id="info_01" type="radio" name="tab_item" checked>
      <label class="tab_item" for="info_01">基本情報</label>
      <input id="info_02" type="radio" name="tab_item">
      <label class="tab_item" for="info_02">構造</label>
      <input id="info_03" type="radio" name="tab_item">
      <label class="tab_item" for="info_03">調整数値</label>
      <div class="tab_content" id="info_01_content">
        <div class="tab_content_description">
          <div class="tab_text">
            <p v-if="isOpen">{{ detailData.openFdCaption === null ? '説明文(公開)' : detailData.openFdCaption }}</p>
            <p v-else>{{ detailData.fdCaption === null ? '説明文' : detailData.fdCaption }}</p>
          </div>
          <!-- <table width="100%" border="1">
            <tbody>
              <tr>
                <th scope="row">材質</th>
                <td><p>text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,</p></td>
              </tr>
              <tr>
                <th scope="row">処理</th>
                <td>text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,</td>
              </tr>
              <tr>
                <th scope="row">色</th>
                <td>text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,</td>
              </tr>
              <tr>
                <th scope="row">加工情報</th>
                <td>text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,text,</td>
              </tr>
              <tr>
                <th scope="row">その他</th>
                <td>&nbsp;</td>
              </tr>
            </tbody>
          </table> -->
        </div>
      </div>
      <div class="tab_content" id="info_02_content">
        <dd-com-space-tree-item
          v-if="space && Object.keys(space).length"
          :fileData="fileData"
          :space="space"
        />
      </div>
      <div class="tab_content" id="info_03_content">
      </div>
    </div>
  </aside>
</template>
<script>
import axios from 'axios'
import {API_URL, KEY_CODE} from '../../constants/App'
import {OBJECT_GROUP_TYPE} from '../../constants/Type'
import * as Api from '../../utils/Api'
import * as App from '../../utils/App'
import RegisterModal from './modal/RegisterModal'
import ComSpaceTreeItem from '../../components/common/ComSpaceTreeItem'
export default {
  name: 'dd-unit-detail',
  components: {
    'dd-register-modal': RegisterModal,
    'dd-com-space-tree-item': ComSpaceTreeItem
  },
  props: {
    detailData: {
      type: Object,
      default: function () {
        return {}
      }
    },
    /** 公開ユニットか */
    isOpen: Boolean
  },
  computed: {
    fileImg: function () {
      if (this.detailData.iconName === undefined || this.detailData.iconName === null) {
        return this.getImage('noimage.svg')
      } else {
        return this.getImage(this.detailData.iconName.replace(/'/g, "¥'") + '.svg')
      }
    }
  },
  data () {
    return {
      // 詳細情報の表示
      isShown: false,
      fileData: {},
      space: {},
      grpName: '',
      imgSave: this.getImage('pages/planning/ic_save_off.svg'),
      imgSheet: this.getImage('pages/planning/ic_sheet_off.svg')
    }
  },
  watch: {
    isShown: function () {
      if (this.isShown) {
        document.addEventListener('keydown', this.onKeydown)
      } else {
        document.removeEventListener('keydown', this.onKeydown)
      }
    },
    detailData: function () {
      let radioList = document.getElementsByName('tab_item')
      console.log(radioList)
      radioList.forEach(e => { e.checked = false })
      radioList[0].checked = true
      if (this.isOpen === true) {
        this.fileData = this.detailData.fileDataModel
        this.getObjGroup(this.detailData.fileDataModel.objectDataModelList[0].objDtlTypeMaster)
      } else {
        this.fileData = this.detailData
        this.getObjGroup(this.detailData.objectDataModelList[0].objDtlTypeMaster)
      }
      this.space = this.fileData.topSpaceModel
    }
  },
  methods: {
    showDetail: function (isShown) {
      this.isShown = isShown
    },
    onDelete: function () {
      App.showModal({
        messages: ['本当に削除しますか？'],
        modalType: 'confirm',
        onOk: this.deleteSubmit
      })
    },
    onRegister: function () {
      // 自社の公開ユニットの場合はユニット登録不可。サーバーサイドでもチェックするが、クライアントでもチェック。
      if (this.isOpen && this.fileData.isOpen && this.fileData.corpId === App.getUserInfo().corpId) {
        App.showModal({
          title: 'エラー',
          messages: ['自社の公開ユニットのため、ユニット登録できません。'],
          messageType: 'error'
        })
        return
      }
      this.$refs.RegisterModalRef.showModal()
    },
    deleteSubmit: function () {
      this.isShown = false
      let payload = {
        spaceJoincd: this.detailData.spaceJoincd
      }
      axios.post(API_URL.UNIT + '/delete', payload)
        .then(response => {
          let modalData = {
            messages: ['削除しました'],
            onOk: () => {
              this.$emit('getFileList', this.isOpen)
            }
          }
          App.showModal(modalData)
        }).catch(error => {
          Api.handleError(error, this.errorMessage, this.validateErrorMessages)
        })
    },
    /** キー押下時 */
    onKeydown: function (event) {
      if (event.keyCode === KEY_CODE.ESC) {
        this.isShown = false
      }
    },
    /** オブジェクトグループ名取得 */
    getObjGroup: function (param) {
      if (!param.objGroupType) {
        this.grpName = 'カテゴリ'
      } else {
        let NameType = Object.keys(OBJECT_GROUP_TYPE).map(key => {
          return OBJECT_GROUP_TYPE[key]
        }).find(objGrpType => objGrpType.code === param.objGroupType)
        this.grpName = NameType.label
      }
    },
    onClickTab: function (event) {
      console.log(event.target)
    },
    isOnSave: function (on) {
      if (on) {
        this.imgSave = this.getImage('pages/planning/ic_save_sel.svg')
      } else {
        this.imgSave = this.getImage('pages/planning/ic_save_off.svg')
      }
    },
    isOnSheet: function (on) {
      if (on) {
        this.imgSheet = this.getImage('pages/planning/ic_sheet_sel.svg')
      } else {
        this.imgSheet = this.getImage('pages/planning/ic_sheet_off.svg')
      }
    },
    getImage: function (image) {
      return App.getDarosResource(image)
    }
  }
}
</script>
<style src="../../css/unit/unit.scss"  lang="scss" scoped></style>
<style scoped>
.cross_btn:hover,
.unitlist:hover,
.tab_item:hover {
  cursor: pointer;
}
.btn-content{
text-align:center;
}
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0);
  display: table;
  transition: opacity .3s ease;
}
.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}
.modal-container {
  width: 400px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .1);
  transition: all .3s ease;
  max-height: 80%;
  overflow: auto;
}
.modal-header {
  border-bottom: 2px solid #ff4500;
  padding-bottom: 10px;
}
.modal-body {
  font-size: 12px;
  margin: 10px 0 20px;
}
.modal-footer{
  text-align: center;
}
.modal-enter {
  opacity: 0;
}
.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
li {
  list-style-type: none;
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/unit/UnitDetail.vue